import { render, staticRenderFns } from "./CardProduct.vue?vue&type=template&id=235db382&scoped=true"
import script from "./CardProduct.vue?vue&type=script&lang=ts"
export * from "./CardProduct.vue?vue&type=script&lang=ts"
import style0 from "./CardProduct.scss?vue&type=style&index=0&id=235db382&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235db382",
  null
  
)

export default component.exports